import { combineReducers, compose, createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "@redux-saga/core";
import { logger, crashReporter } from "../../../store";
import rootSaga from "../sagas";
import {
    activityLogs,
    activityLogsLoading,
    currentActivitiesUsers
} from "../reducers/activityLogs.reducer";
import {
    historyUsers,
    historyUsersLoading
} from "../reducers/historyUsers.reducer";

const historyReducer = combineReducers({
    activityLogs,
    activityLogsLoading,
    historyUsers,
    historyUsersLoading,
    currentActivitiesUsers
});

const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]
    ? window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]({
          name: "History Store"
      })
    : compose;

const sagaMiddleware = createSagaMiddleware();

export const historyStore = createStore(
    historyReducer,
    {},
    composeEnhancers(applyMiddleware(sagaMiddleware, logger, crashReporter))
);

export const historyStoreSelectors = {
    activityLogs: (state = historyStore.getState()) => state.activityLogs,
    activityLogsLoading: (state = historyStore.getState()) =>
        state.activityLogsLoading,
    historyUsers: (state = historyStore.getState()) => state.historyUsers,
    historyUsersLoading: (state = historyStore.getState()) =>
        state.historyUsersLoading,
    currentActivitiesUsers: (state = historyStore.getState()) =>
        state.currentActivitiesUsers
};

sagaMiddleware.run(rootSaga);
